module.exports = __webpack_public_path__ + "static/img/model-bg37.0afcd45.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg37.jpg
// module id = FaQm
// module chunks = 0